<template>
    <div class="container-fluid">
        <Breadcrumb button-url="mailServiceSettingCreate" title="Mail Service Setting"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="loading">
                <Preloader v-bind:class="{preloader: loading}"></Preloader>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <div v-if="mailServiceSettings.length === 0">No MailService Settings</div>
                        <div v-else>
                            <div class="form-group">
                                <input v-model="search" type="text" class="form-control form-control-line"
                                       placeholder="Search Balancer">
                            </div>
                            <div v-if="mailServiceSettings.length > 0">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr :key="index" v-for="(mailServiceSetting, index) in filteredMailServiceSettings">
                                            <td>{{mailServiceSetting.id}}</td>
                                            <td>
                                                <router-link
                                                        :to="{ name: 'mailServiceSettingEdit', params: { id: mailServiceSetting.id }}">
                                                    {{mailServiceSetting.name}}
                                                </router-link>
                                            </td>
                                            <td>
                                                <router-link
                                                        :to="{ name: 'mailServiceSettingEdit', params: { id: mailServiceSetting.id }}"
                                                        class="btn btn-info m-r-10">
                                                    <i class="fa fa-edit"></i> Edit
                                                </router-link>
                                                <button @click="deleteBalancer(mailServiceSetting.id)"
                                                        class="btn btn-danger"
                                                        type="button">
                                                    <i class="fa fa-minus-circle"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate :click-handler="getItems"
                                          :container-class="'pagination justify-content-center'"
                                          :margin-pages="2"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'"
                                          :next-text="'Next'"
                                          :page-class="'page-item'"
                                          :page-count="pageCount"
                                          :page-link-class="'page-link'"
                                          :page-range="3"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :prev-text="'Prev'"
                                          v-if="pageCount > 1"
                                          v-model="page">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import BalancerService from '../services/MailServiceSettingService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';
    
    export default {
        name: 'MailServiceSettings',
        components: {
            Preloader, Breadcrumb
        },
        mixins: [ paginateMixin ],
        data() {
            return {
                mailServiceSettings: [],
                loading: false,
                totalMailServiceSettings: 0,
                page: 1,
                perPage: 10,
                search: null
            }
        },
        mounted() {
            this.getItems(this.page);
        },
        methods: {
            getItems: function (pageNum) {
                this.loading = true;
                BalancerService.getMailServiceSettings(pageNum, this.perPage).then(response => {
                    this.mailServiceSettings = response.data['hydra:member'];
                    this.totalMailServiceSettings = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            deleteBalancer(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return BalancerService.deleteMailServiceSetting(id).then(() => {
                            let index = this.mailServiceSettings.findIndex(obj => obj.id === id);
                            this.mailServiceSettings.splice(index, 1);
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Mail Service Settings has been deleted.`,
                            'success'
                        )
                    }
                })
            }
        },
        computed: {
            filteredMailServiceSettings: function () {
                return this.mailServiceSettings.filter((mailServiceSetting) => {
                    if (this.search === null || this.search === undefined) return true;
                    return mailServiceSetting.name.toLowerCase().includes(this.search.toLowerCase())
                })
            },
            pageCount: function () {
                return Math.ceil(this.mailServiceSettings / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>